import utils from "./utils";

export const DEFAULT_STUDY_COLOR = "#64748b";

const PALETTE = utils.studyColors();

export function normStudyId(value) {
  return String(value ?? "")
    .replace(/[{}]/g, "")
    .trim()
    .toLowerCase();
}

export function pickStudyColorRaw(source = {}) {
  if (!source || typeof source !== "object") return "";
  const raw =
    source.StudySchColor ||
    source.studySchColor ||
    source.StudyColor ||
    source.studyColor ||
    source.StudyColour ||
    source.studyColour ||
    "";
  return String(raw || "").trim();
}

export function resolveStudyDisplayColor(value, fallback = DEFAULT_STUDY_COLOR) {
  const color = String(value || "").trim();
  if (!color) return fallback;
  if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(color)) return color;
  if (/^[0-9a-f]{6}$/i.test(color)) return `#${color}`;

  const lower = color.toLowerCase();
  const byLabel = PALETTE.find(
    (opt) => String(opt.label || "").trim().toLowerCase() === lower,
  );
  if (byLabel) return byLabel.value;

  const withHash = lower.startsWith("#") ? lower : `#${lower}`;
  const byValue = PALETTE.find(
    (opt) => String(opt.value || "").trim().toLowerCase() === withHash,
  );
  if (byValue) return byValue.value;

  if (/^(rgb|hsl)a?\(/i.test(color)) return color;
  return color;
}

export function studyBadgeTextColor(background) {
  const resolved = resolveStudyDisplayColor(background, DEFAULT_STUDY_COLOR);
  const hex = resolved.replace("#", "");
  if (hex.length !== 6 || !/^[0-9a-f]{6}$/i.test(hex)) return "#ffffff";
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.62 ? "#0f172a" : "#ffffff";
}

export function buildStudyColorLookup(rows = []) {
  const map = new Map();
  (rows || []).forEach((row) => {
    const id = normStudyId(row?.StudyId ?? row?.studyId ?? row?.StudyID);
    const color = pickStudyColorRaw(row);
    if (id && color) map.set(id, color);
  });
  return map;
}
